export default "__VITE_ASSET__DlCP1wxr__"